export default "__VITE_ASSET__CshJT8so__"